export default __webpack_public_path__ + "static/media/search_remove_key.49456840.svg";